import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/core/app.component';
import { appConfig } from './app/server/app.config';
import { setupConfig } from '@ionic/core/components';

setupConfig({
  mode: 'md'
});

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error('Error al inicializar la aplicación', err));
